import { xboxProfile } from './xbox'
import { genericProfile } from './generic'
import { keyboardProfile } from './keyboard'
import type { ControllerProfile } from './types'

/**
 * Registry of all controller profiles.
 */
const profiles = new Map<string, ControllerProfile>([
  ['xbox', xboxProfile],
  ['generic', genericProfile],
])

/**
 * Detect controller profile from gamepad ID.
 * Attempts to identify the controller type from the gamepad's ID string.
 */
export function detectProfile(gamepad: Gamepad): ControllerProfile {
  const id = gamepad.id.toLowerCase()

  // Xbox controller detection
  if (id.includes('xbox') || id.includes('microsoft')) {
    return xboxProfile
  }

  // Default to generic for unknown controllers
  return genericProfile
}

/**
 * Get a controller profile by ID.
 */
export function getProfile(id: string): ControllerProfile | undefined {
  return profiles.get(id)
}

/**
 * Get the keyboard profile.
 */
export function getKeyboardProfile() {
  return keyboardProfile
}

/**
 * Register a custom controller profile.
 */
export function registerProfile(profile: ControllerProfile): void {
  profiles.set(profile.id, profile)
}
